import { useCallback } from 'react';

import * as SplashScreen from 'expo-splash-screen';
import { View } from 'react-native';

import { IBaseProps } from '@rbi-ctg/frontend';

export const HideSplashScreen: React.FC = ({ children }: IBaseProps) => (
  <View onLayout={useCallback(() => SplashScreen.hideAsync(), [])}>{children}</View>
);
